import React, {Component} from 'react';
        import {Modal, ModalBody, ModalHeader} from "reactstrap";
        import {request} from "../../util/APIUtils";
        import Table from "../../components/Table/Table";
        import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
        import {RightExists, showAxiosError} from "../../util/Helpers";
        import OdaForm from "./OdaForm";
        import {API_BASE_URL} from "../../constants";
        import './OdaList.css';
        import {Dropdown, Menu, Button, Icon, notification} from 'antd';


        class OdaList extends Component {

            constructor(props) {
        super(props);

        this.state = {
            selectedChamber: null,
            branches: null,
            aliasList: null,
            chambers: [],
            sehirler: [],
            loading: false,
            searching: false,
            searchQuery: undefined,
            total: 0,
            page: 0,
            size: 10,
            manual: false,
            addDeleteModal: false,
            addChamberModal: false,
            NewChamberModal: false,
            maxIdleMinutes: 1,
            remainingSeconds: 20,
            add: false,
        };

        this.listChambers = this.listChambers.bind(this);
        this.cancelUserCreation = this.cancelUserCreation.bind(this);
        this.addNewModal = this.addNewModal.bind(this);
        this.handleSearch = this.handleSearch.bind(this);

    }

    addNewModal() {
        let self = this;
        self.setState({
            selectedChamber: null,
            addNewChamberModal: true,
            add: true
        })
    }

    listChambers(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=ad,asc';
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let params = {
            url: API_BASE_URL + '/oda/fetchOda?page=' + page + '&size=' + size + sortStr + searchQuery,
            method: "get",
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                let chambers = response.data.content;
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    chambers,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    cancelUserCreation() {
        this.setState({
            addChamberModal: false,
            addNewChamberModal: false,
            selectedChamber: null,
            add:false,
        })
        this.listChambers()
    }

    handleEdit(item) {
        let self = this;
        let data = item.id;
        console.log("item.id==>", item.id);
        let params = {
            url: API_BASE_URL + "/oda/" + item.id,
            data: data,
            method: 'get'
        };
        console.log(params);
        request(params).then(function (response) {
            console.log(response.data);
            self.setState({
                mode: 'edit',
                selectedChamber: response.data,
                addChamberModal: true,
                addNewChamberModal: true
            })
        }).catch(function (error) {
            showAxiosError(error);
        });
    }


    handleSearch(searchQuery) {
        this.setState({
            searchQuery,
            searching: true
        }, () => this.listChambers(this.state.accessor, this.state.direction, this.state.page, this.state.size))
    }

    openDeleteModel = (item) => {
        this.setState({handleKomisyonDelete: true});
        this.setState({selectedChamber: item});
    }
    handleKomisyonDelete = (item) => {
        const token = localStorage.getItem("accessToken");
        const apiUrl = API_BASE_URL + `/oda/${item.id}`;

        fetch(apiUrl, {
            method: "DELETE",
            headers: {
                Authorization: "Bearer " + token,
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                this.setState((prevState) => ({
                    chambers: prevState.chambers.filter((chamber) => chamber.id !== item.id),
                }));
            })
            .catch((error) => {
                console.error("There was a problem with the fetch operation:", error.message);
            });
    };


    deleteChamber(selectedChamber) {
        let self = this;
        let id = selectedChamber.id;
        let params = {
            url: API_BASE_URL + '/oda/' + id,
            method: 'delete'
        };
        request(params)
            .then(function (response) {
                self.setState({addDeleteModal: false, selectedChamber: null, handleKomisyonDelete: false});
                self.listChambers(self.state.accessor, self.state.direction, self.state.page, self.state.size);
                notification.success({
                    message: selectedChamber.ad,
                    description: "Komisyon Silindi",
                    duration:30,
                });
            })
            .catch(function (error) {
                showAxiosError(error);
                self.setState({handleKomisyonDelete: false});
            });
    }

    render() {
        const {chambers} = this.state;
        const menu = (
            <Menu>
                <Menu.Item onClick={() => this.handleEdit(this.state.selectedChamber)}>
                    Komisyon Düzenle
                </Menu.Item>
                <Menu.Item onClick={() => this.handleDelete(this.state.selectedChamber)}>
                    Komisyon Sil
                </Menu.Item>
            </Menu>
        );

        const columns = [
            {
                Header: "Komisyon Adı",
                accessor: "ad",
            },
            {
                Header: "Üye Sayısı",
                accessor: "uyeSayisi",

                // Header: "Web Sitesi",
                // accessor: "webSitesiURL",
            },
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div className="textCenter">
                        <Dropdown
                            overlay={
                                <Menu>
                                    <Menu.Item key="edit" onClick={() => this.handleEdit(item, 'edit')}>
                                        Komisyon Düzenle
                                    </Menu.Item>
                                    <Menu.Item key="delete" onClick={() => this.openDeleteModel(item)}>
                                        Komisyon Sil
                                    </Menu.Item>

                                </Menu>
                            }
                            trigger={['click']}
                            onClick={() => this.setState({selectedItem: item})}
                        >
                            <Button
                                style={{
                                    background: '#3b6b96',
                                    height: '30px',
                                    width: '100px',
                                    color: 'white',
                                    borderRadius: '0.375em',
                                    fontSize: "12px",
                                }}
                            >
                                Seçiniz <Icon type="down"/>
                            </Button>
                        </Dropdown>
                    </div>
                )
            }
        ];

        const fields = [
            {
                label: "Komisyon Adı",
                accessor: "komisyonAd",
                type: "text",
                operator: "=",
            },
            /*  {
                  label: "Adres",
                  accessor: "adres",
                  type: "text",
                  operator: "=",
              },
              {
                  label: "Telefon No",
                  accessor: "telefonNo",
                  type: "text",
                  operator: "=",
              } */
        ];
        return (

            <div className="odaList-container">
                <div className="row baseBackground">
                    <div className="col-md-12 satirBasi">
                        <div className="card-header">
                            <h4 className="card-title">Komisyon Listesi</h4>
                        </div>
                        <div className="card-body mt-1">
                            <div className=" ">
                                <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                    <DetailedSearch
                                        fields={fields}
                                        loading={this.state.searching}
                                        onSearch={this.handleSearch}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <Table
                                loading={this.state.loading}
                                loadingText="Kayıtlar getiriliyor..."
                                content={chambers}
                                total={this.state.total}
                                page={this.state.page}
                                manual={this.state.manual}
                                size={this.state.size}
                                options={["5", "10", "20", "50", "100"]}
                                columns={columns}
                                fetchData={this.listChambers}
                                style={{width: "100%"}}
                            />
                        </div>
                        <div className="new-button-holder">
                            <button
                                type="button"
                                data-toggle="tooltip"
                                data-placement="bottom"
                                title="Yeni Komisyon Ekle"
                                disabled={this.state.isLoading}
                                rel="tooltip"
                                style={{
                                    background: 'linear-gradient(#2b93cd, #0a66b7)',
                                    height: '40px',
                                    width: '175px',
                                    float: 'right',
                                    marginRight: '30px',
                                    color: 'white',
                                    borderRadius: '0.375em',
                                }}
                                className="TekBtn add-new-member"
                                onClick={() => this.addNewModal()}>
                                YENİ KOMİSYON EKLE
                            </button>
                        </div>
                    </div>
                    <Modal isOpen={this.state.addNewChamberModal} size="lg" className="ust">
                        <ModalHeader toggle={this.cancelUserCreation}>
                            {this.state.add
                                ?
                                'Yeni Komisyon Ekle'
                                :
                                'Komisyon Düzenle'
                            }
                        </ModalHeader>
                        <ModalBody>
                            <OdaForm saveUser={this.saveUser}
                                     cancelProcess={this.cancelUserCreation}
                                     selectedOda={this.state.selectedChamber}
                                     mode={this.state.mode}
                                     currentUser={this.props.currentUser}
                                     handleSearch={this.handleSearch}/>
                        </ModalBody>
                    </Modal>
                    <Modal isOpen={this.state.handleKomisyonDelete} size="lg" className="ust">
                        <ModalHeader toggle={() => this.setState({handleKomisyonDelete: false})}>
                            Komisyonu Sil
                        </ModalHeader>
                        <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                            <h4>{this.state.selectedChamber ? `"${this.state.selectedChamber.ad}" silinecektir. Emin misiniz?` : null}</h4>
                            <div className="text-right" id="deleteModal">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{background: '#9e9e9e', padding: '10px 54px 10px 23px',float: 'left', width:"150px"}}
                                        rel="tooltip" className="TekBtn vazgec "
                                size="sm"
                                        onClick={() => this.setState({handleKomisyonDelete: false})}>İptal</button>
                                <button type="button"
                                        data-toggle="tooltip"
                                        data-placement="bottom"

                                        style={{
                                            background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                            float: 'right', padding: '10px 54px 10px 23px', width:"150px"
                                        }}
                                        rel="tooltip" className="TekBtn kaydet"
                                        onClick={() => this.deleteChamber(this.state.selectedChamber)}>Onayla</button>
                            </div>
                        </ModalBody>
                    </Modal>

                </div>
            </div>
        )
    }
}

export default OdaList;


// WEBPACK FOOTER //
// ./src/page/odaList/OdaList.js